import React from 'react';
import webCancelSvg from '@/assets/web_cancel.svg';
import webSaveSvg from '@/assets/web_save.svg';
import webPrintSvg from '@/assets/web_print.svg';
import webShareSvg from '@/assets/web_share.svg';
import circleEditSvg from '@/assets/circle_edit.svg';
import circleDeleteSvg from '@/assets/circle_delete.svg';
import webFullPlanPng from '@/assets/web_full_plan.png';
import webAnnotationSvg from '@/assets/web_annotation.svg';
import webFilterSvg from '@/assets/web_filter.svg';
import webFilterFilledSvg from '@/assets/web_filter_filled.svg';
import webLayersSvg from '@/assets/web_layers.svg';
import webMinusSvg from '@/assets/web_minus.svg';
import webPlusSvg from '@/assets/web_plus.svg';
import webIconSendSvg from '@/assets/web_icon_send.svg';

interface IconButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  size?: number;
  className?: string;
  title?: string;
}

export const IconButtonCancel: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webCancelSvg}
        alt="Cancel"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonSave: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webSaveSvg}
        alt="Save"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonPrint: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webPrintSvg}
        alt="Print"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonShare: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webShareSvg}
        alt="Share"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonEdit: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={circleEditSvg}
        alt="Edit"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonDelete: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={circleDeleteSvg}
        alt="Delete"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonFullPlan: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webFullPlanPng}
        alt="Full plan"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonAnnotation: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webAnnotationSvg}
        alt="Annotation"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonFilter: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webFilterSvg}
        alt="Filter"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonFilterFilled: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webFilterFilledSvg}
        alt="Filter"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonLayers: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webLayersSvg}
        alt="Layers"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonMinus: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webMinusSvg}
        alt="Minus"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonPlus: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webPlusSvg}
        alt="Plus"
        width={size}
        height={size}
      />
    </button>
  );
};

export const IconButtonSend: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 36,
  className = '',
  title
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`hover:opacity-70 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed ${className}`}
      title={title}
    >
      <img
        src={webIconSendSvg}
        alt="Send"
        width={size}
        height={size}
      />
    </button>
  );
};
